export const documentValidation = {
  approvedDocument: "Documentul a fost aprobat cu succes!",
  signedDocument: "Documentul a fost semnat cu succes!",
  rejectedDocument: "Documentul a fost respins!",
  confirmedDocument: "Documentul a fost încarcat cu succes!",
};
